import { isClosingDateBasis, type SearchDateBasis } from './search-date-basis'

type WithSearchDateBasis = {
  searchDateBasis?: SearchDateBasis
}

/**
 * 一覧のルーターローダーで、URL に無い日付条件へ初回表示用の既定レンジを補う。
 *
 * 通常検索（暦日）では従来どおり既定レンジを補う。締日基準モード（請求月 / 支払月）では
 * 日付は任意条件なので（#4387 Q-8 = 8-A）、補わずに URL の条件をそのまま返す。
 *
 * 補ってしまうと、利用者が日付欄をクリアして計上月だけで検索したつもりでも、既定の
 * 日付レンジ（配送依頼は本日、運行実績は 7 日前〜前日）が AND 条件として API へ飛び、
 * 該当データがあっても 0 件になる（#4809）。エラーが出ないため該当なしと区別できない。
 */
export const applyDefaultDateRange = <T extends WithSearchDateBasis>(
  defaultDateRange: T,
  search: T
): T =>
  isClosingDateBasis(search.searchDateBasis)
    ? search
    : { ...defaultDateRange, ...search }
